import React from "react";
import CarrentForm from "./CarrentForm";
import FlightForm from "./FlightForm";
import HotelForm from "./HotelForm";
import TransferForm from "./TransferForm";
import SightForm from "./SightForm";

const CategoryForm = (props) => {
  const { category, setIsClicked } = props;
  const [myCategory, setMyCategory] = React.useState("");
  React.useEffect(() => {
    if (category.includes("-")) {
      setMyCategory(category.split("-")[0]);
    } else {
      setMyCategory(category);
    }
  }, [category]);

  switch (myCategory) {
    case "hotel":
      return <HotelForm />;
      break;

    case "flight":
      return <FlightForm />;
      break;

    case "transfer":
      return <TransferForm />;
      break;

    case "carrent":
      return <CarrentForm />;
      break;

    case "sight":
      return <SightForm />;
      break;

    case "visa":
      setIsClicked(false);
      return null;
      break;

    case "insurance":
      setIsClicked(false);
      return null;
      break;

    default:
      return <HotelForm />;
  }
};

export default CategoryForm;
